import fetch from "auth/FetchInterceptor";

const TatService = {};

TatService.fetch = function (params) {
  return fetch({
    url:
      "/fetchTat?start_date=" +
      params.startDate +
      "&end_date=" +
      params.endDate,
    method: "get",
    data: params,
  });
};

export default TatService;
